import {useParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {FormTextField} from '../../ui/forms/input-field/text-field/text-field';
import {Form} from '../../ui/forms/form';
import {AuthLayout} from './auth-layout/auth-layout';
import {
  ResetPasswordPayload,
  useResetPassword,
} from '../requests/reset-password';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useSettings} from '../../core/settings/use-settings';
import {
  AuthCard,
  AuthCardWrap,
  AuthCloseButton,
  AuthPromptCard,
  AuthShell,
  AuthTitle,
  authFieldClass,
  authPrimaryBtnClass,
} from './auth-ui';
import {resolveSiteLogoSrc} from '@common/branding/site-logo';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';

export function ResetPasswordPage() {
  const {token} = useParams();
  const {
    branding,
    registration: {disable: registrationDisabled},
  } = useSettings();
  const isDarkMode = useIsDarkMode();
  const form = useForm<ResetPasswordPayload>({defaultValues: {token}});
  const resetPassword = useResetPassword(form);
  const logoSrc = resolveSiteLogoSrc(branding, isDarkMode);

  return (
    <AuthLayout>
      <StaticPageTitle>
        <Trans message="Reset Password" />
      </StaticPageTitle>
      <AuthShell logoSrc={logoSrc}>
        <AuthCardWrap compact action={<AuthCloseButton to="/login" />}>
          <AuthCard compact>
            <AuthTitle>
              <Trans message="Reset your account password" />
            </AuthTitle>

            <Form
              form={form}
              onSubmit={payload => {
                resetPassword.mutate(payload);
              }}
            >
              <div className="flex w-full flex-col items-center gap-[16px]">
                <FormTextField
                  name="email"
                  type="email"
                  label={null}
                  placeholder="Email"
                  className="w-[350px] max-w-full"
                  inputClassName={authFieldClass}
                  required
                />
                <FormTextField
                  name="password"
                  type="password"
                  label={null}
                  placeholder="New password"
                  className="w-[350px] max-w-full"
                  inputClassName={authFieldClass}
                  required
                />
                <FormTextField
                  name="password_confirmation"
                  type="password"
                  label={null}
                  placeholder="Confirm password"
                  className="w-[350px] max-w-full"
                  inputClassName={authFieldClass}
                  required
                />
                <button
                  type="submit"
                  className={authPrimaryBtnClass}
                  disabled={resetPassword.isLoading}
                  aria-label="Reset password"
                >
                  <Trans message="Reset password" />
                </button>
              </div>
            </Form>
          </AuthCard>
        </AuthCardWrap>

        {!registrationDisabled && (
          <AuthPromptCard
            text={<Trans message="Don't have a CloudTransfer account?" />}
            buttonLabel="Create"
            buttonTo="/register"
          />
        )}
      </AuthShell>
    </AuthLayout>
  );
}
